<template>
  <div id="test-article">
    <router-link :to="'/tests/' + test.sample_type_slug" class="test-goback">
      <h5 class="grey ff ff-valign-center">
        <icon name="ui-chevron-left" color="grey" size=18 />
        <span>Back</span>
      </h5>
    </router-link>
    
    <div v-if="test">
      <h2 v-html="test.name" class="cyan"></h2>
      
      <ul class="test-details ff">
          <li v-if="test.method" class="ff ff-nowrap ff-12 ff-md-auto">
            <strong>Method:</strong>
            <span v-html="test.method"></span>
          </li>
          <li v-if="test.units_of_measurement" class="ff ff-nowrap ff-12 ff-md-auto">
            <strong>Units:</strong>
            <span v-html="test.units_of_measurement"></span>
          </li>
          <li v-if="test.minimum_prepared" class="ff ff-nowrap ff-12 ff-md-auto">
            <strong>Minimum Prepared:</strong> 
            <span v-html="test.minimum_prepared"></span>
          </li>
      </ul>
      
      <div id="test-content">
        <div v-if="test.description" id="test-description" class="test-content-container">
          <div class="test-content" v-html="test.description"></div>
        </div>
        
        <div v-if="test.references" id="test-references" class="test-content-container">
          <strong>References:</strong>
          <div class="test-content" v-html="test.references"></div>
        </div>
        
        <div v-if="test.notes" id="test-notes" class="test-content-container">
          <strong>Notes:</strong>
          <div class="test-content" v-html="test.notes"></div>
        </div>
      </div>
      
      <div v-if="testOptions.dependents.length > 0" id="test-dependents">
        <strong>Options:</strong>
        <div
          v-for="opt in testOptions.dependents"
          :key="'test-opt-'+opt.index"
        >
          <div class="test-options-dependent ff ff-12 ff-align-between ff-valign-center ff-nowrap" v-on:click="toggleOption(opt.index,'dependents')">
            
            <div class="test-option-name ff-fill">
              <span v-html="opt.name"></span> <strong class="test-option-price cyan" :class="opts.dependents.indexOf(opt.index) !== -1 ? 'active' : ''">+${{ opt.price }}</strong>
            </div>
            
            <div 
              class="test-option-toggle ff ff-center ff-nowrap bg-black"
              :class="opts.dependents.indexOf(opt.index) !== -1 ? 'active' : 'inactive'"
            >
              <div class="test-option test-option-true ff ff-center">
                <h5>Yes</h5>
              </div>
              <div class="test-option test-option-false ff ff-center">
                <h5>No</h5>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      
      <div v-if="testOptions.parents.length > 0" id="test-parents">
        <strong>Add with one of the following tests <em>(Required)</em>:</strong>
        <div
          v-for="opt in testOptions.parents"
          :key="'test-opt-'+opt.index"
        >
          <div class="test-options-parent ff ff-12 ff-align-between ff-valign-center ff-nowrap" v-on:click="toggleOption(opt.index,'parents')">
            
            <div class="test-option-name ff-fill">
              <span v-html="opt.name"></span> <strong class="test-option-price cyan" :class="opts.parents.indexOf(opt.index) !== -1 ? 'active' : ''">+${{ opt.price }}</strong>
            </div>
            
            <div 
              class="test-radio-tick ff ff-center ff-nowrap bg-black"
              :class="opts.parents.indexOf(opt.index) !== -1 ? 'active' : 'inactive'"
            >
              <icon name="ui-tick" color="cyan" />
            </div>

          </div>
        </div>
      </div>
      
      <div id="test-actions">
        <ul class="test-actions ff">
          <li v-if="price" class="ff ff-12 ff-sm-auto">
            <div class="test-action-price ff ff-center ff-12 ff-sm-auto btn bg-none border border-default cyan">
              <strong>${{ price }}</strong> <em>ex GST</em>
            </div>
          </li>
          <li v-else class="ff ff-12 ff-sm-auto">
            <div class="test-action ff ff-center ff-12 btn bg-none border border-grey cyan">
              <span>$0</span> <em>ex GST</em>
            </div>
          </li>
          <li class="ff ff-center ff-12 ff-sm-auto">
            <transition name="fade" mode="out-in">
              <div v-if="showEstimateBtn" class="ff ff-center ff-12">
                <div 
                  v-on:click="showAddPopup = !showAddPopup"
                  class="test-action ff ff-center ff-12 btn bg-cyan"
                >
                  <icon name="ui-plus" color="white" size=18 />
                  <span>Add to Estimate</span>
                </div>
              </div>
              <div v-else></div>
            </transition>
            
            <transition name="fade" mode="out-in">
              <div v-if="showAddPopup" class="tests-list-popup tests-list-popup-top bg-dark-grey">
                <div id="test-popup">
                  <div class="tests-list-popup-estimates">
                    <div class="tests-list-popup-existing">
                      <h5 class="white">Add to:</h5>
                      
                      <div 
                        v-for="(estimate,e) in estimates"
                        v-on:click="addToEstimate(
                          test.index,
                          {
                            estimate: e,
                            disabled: (estimateVoidTests[e].disabled.indexOf(test.index) !== -1)
                          }
                        )"
                        class="ff ff-nowrap"
                        :class="{
                          'in-estimate grey': estimateVoidTests[e].selected.indexOf(test.index) !== -1 && estimate.sampleType === test.sample_type, 
                          'not-same-sampletype grey': estimateVoidTests[e].disabled.indexOf(test.index) !== -1 || estimate.sampleType !== test.sample_type
                        }"
                        :title="determineTitleText(estimate, e, test)"
                        :key="'estimate-'+test.index+'-'+e"
                      >
                        {{ estimate.displayedType }} Estimate ({{ e+1 }})
                        <div class="test-popup-tick">
                          <icon name="ui-tick" color="grey" size=16 /> 
                        </div>
                      </div>
                    </div>
                    
                    <div 
                      class="tests-list-popup-new ff ff-valign-center ff-nowrap"
                      v-on:click="addToEstimate(test.index)"
                    >
                      <icon name="ui-plus" color="white" size=18 />
                      <em class="white">New Estimate</em>
                    </div>
                  </div>
                </div>
                
                <div class="tests-list-popup-close" v-on:click="showAddPopup = !showAddPopup">
                  <icon name="ui-cross" color="white" size=18 />
                </div>
              </div>
            </transition>
          </li>
        </ul>
      </div>
      
    </div>
  </div>
</template>

<script>

// @ is an alias to /src
export default {
  name: "test",
  props: [
    "articleSlug",
    "categorySlug"
  ],
  data() {
    return {
      opts: {
        dependents: [],
        parents: []
      },
      test: false,
      testOptions: {
          dependents: [],
          parents: []
      },
      showEstimateBtn: true,
      showAddPopup: false
    }
  },
  computed: {
    price () {
      var price = 0;
      var test = this.test;
      var tests = this.$store.getters.tests;
      
      // Base test price
      if(test) {
        price += parseFloat(test.price);
      }
      
      // Add any active dependents' prices
      if(this.opts.dependents.length > 0) {
        var dependents = this.opts.dependents;
        
        dependents.forEach(function(d){
          
          if(dependents.indexOf(d) !== -1) {
            price += parseFloat(tests[d].price);
          }
          
        });
      }
      
      // Add any active parents' prices
      if(this.opts.parents.length > 0) {
        var parents = this.opts.parents;
        
        parents.forEach(function(p){
          
          if(parents.indexOf(p) !== -1) {
            price += parseFloat(tests[p].price);
          }
          
        });
      }
      
      return price.toFixed(2);
    },
    estimates () {
      var estimates = this.$store.state.calculator.estimates;
      return estimates;
    },
    currentEstimate () {
      var currentEstimate = this.$store.state.calculator.currentEstimate;
      return currentEstimate;
    },
    estimateVoidTests() {
      const storedTests = this.$store.state.tests;
      var estimateVoidTests = [];
      
      if(this.$store.state.calculator.estimates.length > 0){
        this.$store.state.calculator.estimates.forEach(function(estimate){
          var tests = [];
          var testIds = [];
          var conditionalTests = [];
          
          // Void individual tests that exist
          if(estimate.tests.individual.length > 0){
            estimate.tests.individual.forEach(function(test){
              tests.push(test.index);
              testIds.push(test.test_id);
            });
          }
          
          // Void optimal tests that exist
          if(estimate.tests.optimal.length > 0){
            estimate.tests.optimal.forEach(function(test){
              if(tests.indexOf(test.index) === -1) {
                tests.push(test.index);
                testIds.push(test.test_id);
              }
            });
          }
          

          // Void conditional tests
          if(storedTests.length > 0){

            // Filter to tests whose conditionals have been met
            const filteredTests = storedTests.filter(t => {
              let conditionalCheck = false;

              // Any conditionals
              if(t.conditionals.operator === 'any' && t.conditionals.tests.length > 0){
                conditionalCheck = t.conditionals.tests.some(ct => testIds.includes(ct));
              }

              // All conditionals
              if(t.conditionals.operator === 'all' && t.conditionals.tests.length > 0){
                conditionalCheck = t.conditionals.tests.every(ct => testIds.includes(ct));
              }

              return conditionalCheck;
            });

            filteredTests.forEach(function(test){
              conditionalTests.push(test.index);
            });

          }

          estimateVoidTests.push({
            selected: tests,
            disabled: conditionalTests,
          });
          
          
        });
      }
      
      return estimateVoidTests;
    },
    meta() {
      var meta = {
        title: "Tests",
        url: "https://www.csbplab.com.au/tests/"+this.categorySlug+"/"+this.articleSlug,
        desc: "",
        image: ""
      }
      
      let sampleTypes = this.$store.getters.sampleTypes;
      
      if (sampleTypes.length > 0){
        let s = sampleTypes.find(s => s.slug == this.categorySlug);
        
        meta.title = "Tests | "+s.name;
      }
      
      return meta;
    }
  },
  beforeMount() {

  },
  mounted() {
    
  },
  methods: {
    loadTest(){
      var test = false;
      var tests = this.$store.state.tests;
      var testOptions = {
        dependents: [],
        parents: []
      };
      
      if(tests.length > 0) {
        
        if(tests.length > 0) {
          var t = tests.find(t => (t.sample_type_slug == this.categorySlug && t.slug == this.articleSlug));
          
          test = t;
        }
        
        if(test) {
          
          // List of Dependents (if is an individual test)
          if(test.test_type === 2 && test.children.length > 0) {
            testOptions.dependents = tests.filter(t => test.children.indexOf(t.test_id) !== -1 && t.sample_type === test.sample_type && t.test_type === 3); 
          }
          
          // List of Parents, either Package or Individual (if is a dependent test)
          if(test.test_type === 3 && test.parents.length > 0) {
            var individualList = tests.filter(t => test.parents.indexOf(t.test_id) !== -1 && t.sample_type === test.sample_type && t.test_type > 1);
            var parList = tests.filter(t => test.parents.indexOf(t.test_id) !== -1 && t.sample_type === test.sample_type && t.test_type === 0);
            var packages = tests.filter(t => test.parents.indexOf(t.test_id) === -1 && t.sample_type === test.sample_type && t.test_type === 0);
            
            // Add packages
            parList.forEach(function(p){
              
              // Check for packages that are the same (minus the dependent test)
              var minusDependent = p.children.filter(ct => ct !== test.test_id);
              minusDependent.sort(function(a, b){return a - b});
              
              // Loop through all packages that don't have the dependent
              for (var m = 0; m < packages.length; m++) {
                
                var arrToCmp = packages[m].children;
                var matchingPackage = true;
                arrToCmp.sort(function(a, b){return a - b});
                
                // If the package's child count is the same as the compared package's child count... proceed
                if(minusDependent.length === arrToCmp.length) {
                  for (var j = 0; j < minusDependent.length; j++) {
                    // If each index of comparative arrays don't match, 'then matchingPackage' to false 
                    if (arrToCmp[j] !== minusDependent[j]) {
                      matchingPackage = false;
                    }
                  }
                } else {
                  matchingPackage = false;
                }
                
                // If we have a match, then add it to the parents list
                if(matchingPackage) {
                  testOptions.parents.push(packages[m]);
                }
                
              }
            });
            
            // Add individual tests
            individualList.forEach(function(i){
              testOptions.parents.push(i);    
            });

            // Set estimate button visibility based on whether there are any parent options
            this.showEstimateBtn = false;
          }

          this.test = test;
          this.testOptions = testOptions;
          
        }
      }
    },
    toggleOption(testIndex,optionGroup) {
      
      // If is currently toggled, remove from option group array
      if(this.opts[optionGroup].indexOf(testIndex) !== -1) {
        
        // Filter out option from currently active options
        var opt = this.opts[optionGroup].filter(i => i !== testIndex);
        
        // Reset to filtered list of options
        this.opts[optionGroup] = opt;
        
      // If is NOT currently toggled, add to option group array
      } else {
        
        // Push to option group array
        this.opts[optionGroup].push(testIndex);
      
      }

      this.showEstimateBtn = this.opts.parents.length > 0 ? true : false;
    },
    addToEstimate(testIndex, params = {estimate: false, disabled: false}) {
      var vm = this;
      var estimateIndex = params.estimate;
      var alreadyExists = false;
      var isSameSampleType = true;
      var estimateType = 'new estimate';
      
      // Conditional checks
      if(estimateIndex !== false){
        var estimate = this.$store.state.calculator.estimates[estimateIndex];
        
        if(estimate.tests.individual.some(t => t.index === testIndex) || estimate.tests.optimal.some(t => t.index === testIndex)) {
          alreadyExists = true;
        }
        
        if(this.$store.state.tests[testIndex].sample_type !== estimate.sampleType) {
          isSameSampleType = false;
        }
        
        estimateType = 'existing estimate';
      } 
      
      // If doesn't exist and is same sample type
      if(!alreadyExists && isSameSampleType && !params.disabled){
        
        this.showAddPopup = false;
        setTimeout(function() {
          
          var test = [testIndex];
          var tests = test.concat(vm.opts.dependents,vm.opts.parents);

          // Dispatch main test
          vm.dispatchToEstimate(tests,estimateIndex);
          
        }, 301);
        
        this.$gtm.trackEvent({
          'event': 'tests',
          'action': 'click',
          'test-category': this.$store.state.tests[testIndex].sample_type_slug,
          'test-name': this.$store.state.tests[testIndex].name,
          'add-to': estimateType
        });
        
      }
      
    },
    dispatchToEstimate(testIndex,estimateIndex = false){
      this.$store.dispatch("addToEstimate", {
        test: testIndex,
        estimate: estimateIndex
      });
    },
    determineTitleText(estimate, estimateIndex, test){

      let message = 'Add to this estimate';

      if(estimate.sampleType !== test.sample_type){
        message = 'Cannot add to an estimate of a different sample type';
      }else{

        if(this.estimateVoidTests[estimateIndex].selected.indexOf(test.index) !== -1){
          message = 'Already added to this estimate';
        }

        if(this.estimateVoidTests[estimateIndex].disabled.indexOf(test.index) !== -1){
          message = 'This test cannot be paired with one of the other tests in this estimate';
        }

      }

      return message;

    }
  },
  watch:{
    '$store.state.tests': {
      handler() {
        this.loadTest()
      },
      immediate: true
    },
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
};
</script>